/**
 * @flow
 * Created by neo on 18.07.17.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col } from 'reactstrap';

type Props = {
  children: React.Node,
  hide: boolean,
  title: string,
};

@observer
export default class DataTableRow extends React.Component<Props, void> {
  static defaultProps = {
    hide: false,
    wide: false,
  };

  render() {
    const { hide, children, title } = this.props;
    if (!hide) {
      return (
        <tr>
          <td style={{ fontFamily: 'Lato-Bold, sans-serif'}} className="font-weight-bold">{title}</td>
          <td style={{ fontFamily: 'Lato-Light, sans-serif'}}>{children}</td>
        </tr>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/DataTableRow.js